export default {
  computed: {
    parentRoute() {
      let firstMatch = 0
      let paths = _.map(this.$router.currentRoute.matched, v => v.path)
      _.each(this.$router.currentRoute.matched, (r, index) => {
        if (
          r.path == this.$router.currentRoute.path ||
          r.path ==
            this.$router.currentRoute.path.substr(0, this.$router.currentRoute.path.length - 1)
        ) {
          firstMatch = index
          return false
        }
      })

      // ========
      // INFO: When backing from '/verification', wrong route parent route is generated ('/profile/phone' instead of '/profile/phone/').This causes further error: Going form '/profile/phone' to '/profile/phone/verification' routes app to base route '/'.

      // sillypatch
      let result = this.$router.currentRoute.matched[firstMatch - 1]
      if (this.$router.currentRoute.matched[firstMatch - 1].path == '/profile/phone') {
        result = { ...result, path: '/profile/phone/' }
      }

      return result
      // return this.$router.currentRoute.matched[firstMatch-1]
      // ========
    },
  },
}
